/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from "axios";
import axiosRetry from "axios-retry";
import VueAxios from "vue-axios";
import Argon from "./plugins/argon-kit";
import Paginate from 'vuejs-paginate';
import './registerServiceWorker';
import VueHead from "vue-head";
import './assets/vendor/espace-icon-sns/icon-sns.css';

Vue.config.productionTip = false;
Vue.use(BootstrapVue)
Vue.use(VueAxios,axios,axiosRetry(axios, {retries: 3}));
Vue.use('paginate', Paginate);
Vue.use(Argon);
Vue.use(VueHead)

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
